import { ReactNode } from "react";
import styled from "styled-components";
import { layout, space } from "styled-system";

export interface ListItemProps {
  /**
  Allows the user to specify any custom styles.
  */
  css?: string;

  children: ReactNode;
}

export const StyledListItem = styled.li<Partial<ListItemProps>>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  text-decoration: none;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  ${layout}
  ${space}
  ${(props) => props.css}
`;

export default function ListItem({ children, ...props }: ListItemProps) {
  return <StyledListItem {...props}>{children}</StyledListItem>;
}
